<template>
    <div>
        <div class="meettingIndex">
            <div class="header bs pt-30 pb-30 pl-30 pr-30">
                <div class="fl logo"><img src="@/assets/images/meetyi_logo.png"></div>
                <div class="fr index flex-v"><router-link to="/"><img src="@/assets/images/header_ico_index.png"></router-link></div>
            </div>
            <div class="banner bs pl-30 pr-30 mb-30" v-if="info.cover_url">
                <div class="bannerMain shadow fillet">
                    <img :src="info.cover_url">
                </div>
            </div>
            <div class="meetingContent bs pl-30 pr-30">
                <div class="easyInformation bs pt-30 pr-30 pb-5 pl-30 fillet shadow mb-30">
                    <div class="title font-17">
                        <div class="top mb-10">{{info.title}}</div>
                        <div class="bottom">
                            <div class="state font-12 blue" v-if="info.start_date > now">报名中</div>
                            <div class="state font-12 green" v-else-if="info.start_date <= now && now <= info.end_date">进行中</div>
                            <div class="state font-12 gray" v-else>已结束</div>
                        </div>
                    </div>
                    <div class="easyList bottom-line pt-25 pb-25">
                        <div class="top mb-10 font-13">会议时间</div>
                        <div class="bottom font-14">{{info.hold_date}}</div>
                    </div>
                    <div class="easyList pt-25 pb-25">
                        <div class="top mb-10 font-13">会议地址</div>
                        <div class="bottom font-14">{{info.address}}</div>
                    </div>
                </div>
                <div class="functionButton fillet shadow bs pt-40 pb-40 mb-30">
                    <ul>
                        <li class="fl">
                            <div class="a" @click="scrollToMount('process')" v-if="info.process.length > 0">
                                <div class="top flex-v font-11"><img src="@/assets/images/meetingIndex_ico06.png"></div>
                                <div class="bottom" style="color:#555">会议议程</div>
                            </div>
                        </li>
                        <li class="fl">
                            <div class="a" @click="scrollToMount('guest')" v-if="info.guest.length > 0">
                                <div class="top flex-v font-11"><img src="@/assets/images/meetingIndex_ico05.png"></div>
                                <div class="bottom" style="color:#555">会议嘉宾</div>
                            </div>
                        </li>
                        <li class="fl">
                            <div class="a" @click="scrollToMount('location')" >
                                <div class="top flex-v font-11"><img src="@/assets/images/meetingIndex_ico07.png"></div>
                                <div class="bottom" style="color:#555">会议定位</div>
                            </div>
                        </li>
                        <li class="fl" v-if="material.length>0">
                            <router-link class="a" :to="'/material/' + id">
                                <div class="top flex-v font-11"><img src="@/assets/images/meetingIndex_ico04.png"></div>
                                <div class="bottom" style="color:#555;">会议资料</div>
                            </router-link>
                        </li>
                        <li class="fl">
                            <div class="a" @click="scrollToMount('description')">
                                <div class="top flex-v font-11"><img src="@/assets/images/meetingIndex_ico01.png"></div>
                                <div class="bottom" style="color:#555">会议简介</div>
                            </div>
                        </li>
                        <!--<li class="fl">
                            <router-link :to="'/activity/' + id">
                                <div class="top flex-v font-11"><img src="@/assets/images/meetingIndex_ico02.png"></div>
                                <div class="bottom">积分活动</div>
                            </router-link>
                        </li>-->
                        <!--<li class="fl">
                            <router-link :to="'/activity/' + id">
                                <div class="top flex-v font-11"><img src="@/assets/images/meetingIndex_ico03.png"></div>
                                <div class="bottom">更多互动</div>
                            </router-link>
                        </li>-->
                        <div class="clear"></div>
                    </ul>
                </div>
                <div class="agenda fillet shadow" v-if="info.process.length > 0" ref="process">
                    <div class="mettingTitle font-13 flex-hv pt-30 pb-30">
                        <div class="fl"><img src="@/assets/images/mettingTitle_ico.png"></div>
                        <div class="fl font pl-30 pr-30">会议议程</div>
                        <div class="fr"><img src="@/assets/images/mettingTitle_ico.png"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="mettingDateSwitching">
                        <ul>
                            <li :class="'font-15 fl ' + (current_index === index ? 'selection' : '')" v-for="(item, index) in info.process" :key="index" @click="current_index = index;current_process = info.process[index].process">{{item.date|strtotime|date('m-d')}}</li>
                            <div class="clear"></div>
                        </ul>
                    </div>
                    <div class="agendaMain bs pl-30 pr-30 pb-30 mb-30">
                        <div :class="'agendaMainList mb-30 ' + cls(item)" v-for="(item, index) in current_process" :key="index">
                            <div class="fl ico pt-45"><img src="@/assets/images/li_ico.png"></div>
                            <div class="fl right fillet shadow bs pl-30 pr-30 pt-30 pb-30">
                                <div class="fl identification">
                                    <div class="time font-19 ">{{item.start_time}}</div>
                                    <div class="state flex-hv font-11" v-if="cls(item) === 'blue'">进行中</div>
                                    <div class="state flex-hv font-11" v-if="cls(item) === 'green'">未开始</div>
                                    <div class="state flex-hv font-11" v-if="cls(item) === 'red'">已结束</div>
                                </div>
                                <div class="fr content">
                                    <div class="title font-16 mb-10">{{item.title}}</div>
                                    <div class="font font-13 mb-10">{{item.content}}</div>
                                    <div class="total flex-v">
                                        <div class="fl img"><img src="@/assets/images/time_ico.png"></div>
                                        <div class="fl">{{item.start_time}}{{item.end_time ? '-' + item.end_time : ''}}</div>
                                        <div class="clear"></div>
                                    </div>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                </div>

                <!-- 会议嘉宾 -->
                <div class="mettingInvitation fillet shadow bs pl-30 pr-30 pb-30 mb-30" ref="guest" v-if="info.guest.length > 0">
                    <div class="mettingTitle font-13 flex-hv pt-30 pb-30">
                        <div class="fl"><img src="@/assets/images/mettingTitle_ico.png"></div>
                        <div class="fl font pl-30 pr-30">会议嘉宾</div>
                        <div class="fr"><img src="@/assets/images/mettingTitle_ico.png"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="invitation-content">
                        <div class="list mb-20" v-for="(item, index) in info.guest" :key="index">
                            <div class="fl left flex-hv">
                                <div>
                                    <div class="photo flex-hv"><img :src="item.avatar_url" alt=""></div>
                                    <div class="name font-14">{{item.title}}</div>
                                    <div class="work font-12">{{item.position}}</div>
                                </div>
                            </div>
                            <div class="fl right">
                                <div class="frame">
                                    <div class="right-list font-13 mb-10">
                                        <div class="fl ico"><img src="@/assets/images/invitation_list_ico.png"></div>
                                        <div class="fl text">{{item.company}}</div>
                                        <div class="clear"></div>
                                    </div>
                                    <div class="right-list font-12">
                                        <div class="fl ico"><img src="@/assets/images/invitation_list_ico.png"></div>
                                        <div class="fl text introduce">{{item.description}}</div>
                                        <div class="clear"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                </div>

                <div class="address fillet shadow bs pl-30 pr-30 pb-30 mb-30" ref="location" v-if="center.lat && center.lng">
                    <div class="mettingTitle font-13 flex-hv pt-30 pb-30">
                        <div class="fl"><img src="@/assets/images/mettingTitle_ico.png"></div>
                        <div class="fl font pl-30 pr-30">会议定位</div>
                        <div class="fr"><img src="@/assets/images/mettingTitle_ico.png"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="detailedAddress mb-20 flex-v" @click="map">
                        <div class="fl left">
                            <div class="placeName font-15">{{info.location}}</div>
                            <div class="detailed font-12">{{info.address}}</div>
                        </div>
                        <div class="fr right">
                            <a href="#"><img src="@/assets/images/mapNavigation_ico.png"></a>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div class="address-content">
                        <baidu-map class="address-main" :center="center" :zoom="14" :ak="ak" style="width:100%;height:2.8rem">
                            <bm-marker :position="center" :dragging="false" :offset="{width:0, height:10}" :icon="{url: url + 'static/wap/images/addressMark_ico.png', size: {width: 30, height: 60}}" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
                        </baidu-map>
                    </div>
                </div>

                <div class="agenda fillet shadow" v-if="info.description" ref="description">
                    <div class="mettingTitle font-13 flex-hv pt-30 pb-30">
                        <div class="fl"><img src="@/assets/images/mettingTitle_ico.png"></div>
                        <div class="fl font pl-30 pr-30">会议简介</div>
                        <div class="fr"><img src="@/assets/images/mettingTitle_ico.png"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="mettingDateSwitching pb-25" v-html="info.description" style="font-size: 15px!important;line-height:1.6"></div>
                </div>

            </div>
            <div class="bottomDistance"></div>
            <self-menu :id="id"></self-menu>
        </div>
    </div>
</template>

<script>
    import BaiduMap from 'vue-baidu-map/components/map/Map'
    import BmMarker from 'vue-baidu-map/components/overlays/Marker'
    let that
    export default {
        name: "index",
        props: ['id'],
        components: {
            BaiduMap,
            BmMarker,
        },
        data () {
            return {
                now: Date.parse(new Date())/1000,
                url: process.env.VUE_APP_url,
                ak: process.env.VUE_APP_BMapKey,
                info: {process:[],guest:[]},
                current_index: 0,
                current_process: [],
                center: {lng: 0, lat: 0},
					 material:[]
            }
        },
        methods: {
            cls (item) {
                let cls
                let start_time = that.$common.strtotime(that.$common.date('Y-m-d', item.date) + ' ' + item.start_time)
                let end_time = that.$common.strtotime(that.$common.date('Y-m-d', item.date) + ' ' + item.end_time)
                if(end_time){
                    if(start_time < that.now && that.now < end_time){
                        cls = 'blue'
                    }else if(start_time > that.now){
                        cls = 'green'
                    }else if(end_time < that.now){
                        cls = 'red'
                    }
                }else{
                    if(start_time > that.now){
                        cls = 'green'
                    }else{
                        cls = 'red'
                    }
                }
                return cls
            },
            map () {
                that.$jssdk.openLocation({
                    latitude: that.center.lat - 0.008, // 纬度，浮点数，范围为90 ~ -90
                    longitude: that.center.lng - 0.008, // 经度，浮点数，范围为180 ~ -180。
                    name: that.info.location, // 位置名
                    address: that.info.address, // 地址详情说明
                    scale: 14, // 地图缩放级别,整形值,范围从1~28。默认为最大
                    infoUrl: window.location.href // 在查看位置界面底部显示的超链接,可点击跳转
                });
            },
            scrollToMount (ref) {
                this.$refs[ref].scrollIntoView(true);
                //document.body.scrollTop = this.$refs[ref].offsetTop
            }
        },
        mounted() {
            that = this
            this.$api.meeting.read(this.id).then(function (res) {
                that.info = res.data
                if(that.info.description) {
                    that.info.description = that.info.description.replaceAll('\t','\u3000')
                }
                if(that.info.process.length > 0) {
                    that.current_process = that.info.process[0].process
                }
                that.center.lng = that.info.lng
                that.center.lat = that.info.lat
            })
				this.$api.meeting.material(this.id).then(function(res){
				    that.material = res.data
				})

        }
    }
</script>

<style scoped>
    .mettingInvitation .invitation-content .list {
        min-height: 130px;
    }
    .address .detailedAddress {
        padding: 0.2rem 0;
    }
    .banner { height:auto }
    .banner .bannerMain { height:auto }
</style>
